// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hp7Y","question":"styles_question__2LR0a","description":"styles_description__2sMoR"};